import type { AccountInput, CreditDetails } from '@/api/generated/model';

export type AccountFormData = {
  name?: string;
  type?:
    | 'bank'
    | 'checking'
    | 'savings'
    | 'investment'
    | 'retirement'
    | 'real-estate'
    | 'crypto'
    | 'alternative'
    | 'liability';
  balance?: number;
  institution?: string;
  ownerId?: string;
  creditDetails?: CreditDetails;
};

export function toAccountInput(data: AccountFormData, currency: string): AccountInput | null {
  if (!data.name || !data.type || data.balance === undefined) {
    return null;
  }

  return {
    name: data.name,
    type: data.type,
    balance: data.balance,
    institution: data.institution || undefined,
    ownerId: data.ownerId || undefined,
    currency,
    creditDetails: data.creditDetails,
  };
}
